import { getErrorResponse, getErrorStatus, getErrorText } from '../../../common/api/errors'

const SAVE_FAILED = 'Произошла ошибка при сохранении'

/**
 * What the risk-score correction forms show for a failed save: the field errors of a validation refusal
 * under their fields, otherwise one sentence (`getErrorText`: the backend reason, a 403 with its reason,
 * the fixed 503 text, the form's text for a server failure).
 */
export const riskScoreSaveErrors = (e: unknown): Record<string, string> => {
  const status = getErrorStatus(e)
  const errors = getErrorResponse<Record<string, string>>(e)
  const hasFieldErrors =
    !!errors && !Array.isArray(errors) && Object.keys(errors).some((key) => key !== 'general_error')

  if (status !== undefined && status < 500 && status !== 403 && hasFieldErrors) {
    return errors as Record<string, string>
  }

  return { general_error: getErrorText(e, SAVE_FAILED, { withFieldName: false }) }
}
